
import Vue from 'vue'

Vue.filter('filterOutPaperByTitle', function(papers, titels){  
            
    return papers.filter( p=> titels.includes(p.paper.titleId))
  })

Vue.filter('filterOutPaperByDeliveryDate', function(papers, dates){  
    return papers.filter(( {deliveryDate})=> !dates.includes(deliveryDate.substring(0,10)))
  })

Vue.filter('filterOutPaperByTitleEditionId', function(papers, filtersPaper){  
    return papers.filter(p=> !filtersPaper.includes(p.id.substring(0,p.id.lastIndexOf(':')) )) 
})

Vue.filter('filterOutPaperByTitleEditionIdAndDeliveryDate', function(papers, filtersPaper,dates){  
    
    return  papers.filter((p=> !(filtersPaper.includes(p.id.substring(0,p.id.lastIndexOf(':')) ) && dates.includes(p.deliveryDate.substring(0,10)))))
    // if(filtersPaper.any(f=>f.id.substring(0,f.id.lastIndexof(':')) === id) &&  !dates.includes(paper.deliveryDate.substring(0,10))){
    //     return true    
    // }else{
    //     return false
    // }
})

  